export const operationsList = {
  LocalTrucker: [{ name: 'Local Trucker', value: 'local_trucker' }],
  Intermediate: [{ name: 'Intermediate Trucker', value: 'intermediate' }],
  LongHaulTrucker: [{ name: 'Long Haul Trucker', value: 'long_haul_trucker' }],
  IntermodalOrPort: [{ name: 'Intermodal or Port', value: 'intermodal_or_port' }],
  HotShot: [
    {
      name: 'Hot Shot (TGL and NTL not available for Class 3 Vehicles)',
      value: 'hot_shot',
    },
  ],
  EndDumperUnits: [{ name: 'End Dumper Units', value: 'end_dumper_units' }],
  RefrigeratedTrailer: [{ name: 'Refrigerated Trailer', value: 'refrigerated_trailer' }],
  OversizedOrOverweight: [{ name: 'Oversized or Overweight', value: 'oversized_or_overweight' }],
  AutomobileHauler: [
    {
      name: 'Automobile Hauler [Excluded for Cargo and NTL]',
      value: 'automobile_hauler',
    },
  ],
  HouseholdGoodsMover: [{ name: 'Household Goods Mover', value: 'household_goods_mover' }],
  UIIAIntermodal: [{ name: 'UIIA - Intermodal', value: 'uiia_intermodal' }],
  MoreOptions: [
    { name: 'Ambulance, EMT, Mobile Blood Banks', value: 'ambulance_emt_mobile_blood_banks' },
    { name: 'Armored Cars', value: 'armored_cars' },
    { name: 'Arms, Ammunition, Fireworks', value: 'arms_ammunition_fireworks' },
    { name: 'Boat Haulers', value: 'boat_haulers' },
    { name: 'Automobile Dismantlers', value: 'automobile_dismantlers' },
    { name: 'Boom Trucks', value: 'boom_trucks' },
    { name: 'Brokerage', value: 'brokerage' },
    { name: 'Cannabis Haulers', value: 'cannabis_haulers' },
    { name: 'Carnivals, Circus', value: 'carnivals_circus' },
    { name: 'Cement Mixers, Pumpers', value: 'cement_mixers_pumpers' },
    { name: 'Coal Haulers', value: 'coal_haulers' },
    { name: 'Contractors, Contractor Equipment Mobile Equipment', value: 'contractors_equipment' },
    { name: 'Cotton Haulers', value: 'cotton_haulers' },
    {
      name: 'Courier Services, magazines, news delivery, parcel, film delivery',
      value: 'courier_services',
    },
    { name: 'Drive Away, Transporter Plates', value: 'drive_away_transporter' },
    { name: 'Driving Schools', value: 'driving_schools' },
    { name: 'Dump Trucks S&G', value: 'dump_trucks_sg' },
    { name: 'Egg Haulers', value: 'egg_haulers' },
    {
      name: 'Fast food delivery, including restaurant take-out delivery',
      value: 'fast_food_delivery',
    },
    { name: 'Final Delivery', value: 'final_delivery' },
    { name: 'Freight Brokerage', value: 'freight_brokerage' },
    { name: 'Garbage/Refuse', value: 'garbage_refuse' },
    { name: 'Hazmat, Nuclear, Biological', value: 'hazmat_nuclear_biological' },
    { name: 'Household Good Movers', value: 'household_good_movers' },
    { name: 'Livestock Transporters', value: 'livestock_transporters' },
    { name: 'Logging Operations', value: 'logging_operations' },
    { name: 'Milk Haulers', value: 'milk_haulers' },
    { name: 'Mobile cranes, Vehicles with buckets', value: 'mobile_cranes_buckets' },
    { name: 'Mobile Home Toters', value: 'mobile_home_toters' },
    { name: 'Mobile Home Toters, Building Movers', value: 'mobile_home_building_movers' },
    { name: 'Municipal', value: 'municipal' },
    { name: 'Operating outside of US', value: 'operating_outside_us' },
    { name: 'Operations using double/triple trailers', value: 'double_triple_trailers' },
    {
      name: 'Oversized/Overweight haulers requiring pilot cars',
      value: 'oversized_overweight_pilot',
    },
    { name: 'Owned Units, Rented or Leased to Others', value: 'owned_units_rented_leased' },
    { name: 'Private Passenger Vehicles', value: 'private_passenger_vehicles' },
    {
      name: 'Public Livery: Buses, taxis, black car, ride share, shuttle, day care, church',
      value: 'public_livery',
    },
    { name: 'Rental Leasing, Demo Vehicles', value: 'rental_leasing_demo' },
    { name: 'Salvage, Scrap Metal', value: 'salvage_scrap_metal' },
    { name: 'Steel Dealers', value: 'steel_dealers' },
    { name: 'Tankers Hauling Flammable Liquids', value: 'tankers_flammable_liquids' },
    { name: 'Towing/Repossession', value: 'towing_repossession' },
    { name: 'Vendor Trucks', value: 'vendor_trucks' },
    { name: 'Dump Trucks (Other)', value: 'dump_trucks_other' },
    { name: 'Dump Trucks (Sand and Gravel)', value: 'dump_trucks_sand_gravel' },
    { name: 'Logging', value: 'logging' },
    { name: 'Tankers', value: 'tankers' },
  ],
};

export const producerOperationsList = {
  GeneralFreight: [{ name: 'General Freight', value: 'general_freight' }],
  FlatBed: [{ name: 'Flat Bed', value: 'flat_bed' }],
};
